export default __webpack_public_path__ + "static/media/logo-collection.84c25fc1.png";